import { ImSpinner2 } from "react-icons/im";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { Button as MuiButton, Box, useTheme } from "@mui/material";
import { LockReset as ForgotPasswordIcon } from "@mui/icons-material";

interface ForgotPasswordSubmitViewProps {
  isLoading: boolean;
}
const ForgotPasswordSubmitView: React.FC<ForgotPasswordSubmitViewProps> = ({
  isLoading,
}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const theme = useTheme();
  return (
    <Box sx={{ mt: 2 }}>
      <MuiButton
        variant="contained"
        fullWidth
        size="large"
        type="submit"
        disabled={isLoading}
        startIcon={
          isLoading ? (
            <Box
              component="span"
              sx={{
                display: "inline-flex",
                animation: "spin 1s linear infinite",
                "@keyframes spin": {
                  "0%": { transform: "rotate(0deg)" },
                  "100%": { transform: "rotate(360deg)" },
                },
              }}
            >
              <ImSpinner2 size={20} />
            </Box>
          ) : (
            <ForgotPasswordIcon />
          )
        }
        className="!bg-zinc-900"
        sx={{
          py: 1.5,
          px: 3,
          borderRadius: 2,
          textTransform: "none",
          fontSize: "1rem",
          fontWeight: 600,

          "&:disabled": {
            background: theme.palette.grey[300],
            color: theme.palette.grey[500],
            boxShadow: "none",
            transform: "none",
          },
          transition: "all 0.2s ease-in-out",
        }}
      >
        {isLoading ? t("actions.submitting") : t("actions.send")}
      </MuiButton>
    </Box>
  );
};

export default ForgotPasswordSubmitView;
